import React from 'react';
import '../styles/Safety.scss';

const Safety = () => {
    return (
        <section className="safety">
            <div className="container">
                <h2 className="section-title">Uncompromising <span>Safety</span></h2>
                <div className="safety-grid">
                    <div className="safety-item">
                        <h3>01. AI Navigation</h3>
                        <p>Our quantum AI monitors orbital trajectories 500x per second, ensuring zero collision risk.</p>
                    </div>
                    <div className="safety-item">
                        <h3>02. Radiation Shielding</h3>
                        <p>Triple-layer magnetic fields protect you from solar flares and cosmic rays.</p>
                    </div>
                    <div className="safety-item">
                        <h3>03. Emergency Stasis</h3>
                        <p>In the unlikely event of hull breach, instant stasis pods preserve life for up to 100 years.</p>
                    </div>
                    <div className="safety-item">
                        <h3>04. Medical Bay</h3>
                        <p>Fully autonomous surgical suites capable of treating any known zero-g ailment.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Safety;
